import React, { useState } from 'react'
import { ButtonSection } from '@/components/Layout'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import { Form, FormGroup, Label, Row, Col } from 'reactstrap'
import Icon from '@/components/Icon'
import { Button } from '@/components/button'
import CheckBox from '@/components/CheckBox'
import LoadingIndicator from '@/components/LoadingIndicator'
import { NumericInput } from '@/components/inputs'
import ErrorBoundary from '@/components/ErrorBoundary'

import Resx from '@/components/Resx'

const RsaKeyPolicyForm = (props) => {
  const [minimalRsaKeyLength, setMinimalRsaKeyLength] = useState(props.minimalPasswordLength)
  const [isLowerCaseCharRequired, setIsLowerCaseCharRequired] = useState(props.isLowerCaseCharRequired)
  const [isUpperCaseCharRequired, setIsUpperCaseCharRequired] = useState(props.isUpperCaseCharRequired)
  const [isNumberCharRequired, setIsNumberCharRequired] = useState(props.isNumberCharRequired)
  const [isNonLetterOrDigitCharRequired, setIsNonLetterOrDigitCharRequired] = useState(props.isNonLetterOrDigitCharRequired)

  const { localize, fetching, updating } = props
  if (fetching || updating) { return <LoadingIndicator /> }

  const doSave = () => {
    props.save({
      minimalPasswordLength: minimalRsaKeyLength,
      isLowerCaseCharRequired,
      isUpperCaseCharRequired,
      isNumberCharRequired,
      isNonLetterOrDigitCharRequired
    })
  }

  return (
    <ErrorBoundary>
      <ValidationBoundary>
        <Form>
          <Row>
            <Col sm='6'>
              <FormGroup>
                <Label style={{ display: 'block' }}><Resx name='Security.MinimalPasswordLength' /></Label>
                <Validator name='minimalPasswordLength' value={minimalRsaKeyLength} required min={1} max={30}>
                  <NumericInput integerOnly value={minimalRsaKeyLength} onChange={value => setMinimalRsaKeyLength(value)} />
                </Validator>
              </FormGroup>
            </Col>
            <Col sm='6'>
              <FormGroup className='mt-3 ml-3'>
                <CheckBox id='isLowerCaseCharRequired' checked={isLowerCaseCharRequired} onChange={value => setIsLowerCaseCharRequired(value)} label={localize('Security.RequiredLowerCaseChars')} />
                <CheckBox id='isUpperCaseCharRequired' checked={isUpperCaseCharRequired} onChange={value => setIsUpperCaseCharRequired(value)} label={localize('Security.RequireUpperCaseChars')} />
                <CheckBox id='isNumberCharRequired' checked={isNumberCharRequired} onChange={value => setIsNumberCharRequired(value)} label={localize('Security.RequireNumbers')} />
                <CheckBox id='isNonLetterOrDigitCharRequired' checked={isNonLetterOrDigitCharRequired} onChange={value => setIsNonLetterOrDigitCharRequired(value)} label={localize('Security.RequireSpecialChars')} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm='12'>
              <ButtonSection>
                <div className='ml-auto'>
                  <ValidationState render={({ isValid }) =>
                    <Button id='save-button' color='success' disabled={!isValid} onClick={doSave} ><Icon name='save' />
                      <span>
                        <Resx name='Common.Save' />
                      </span>
                    </Button>
                  } />
                </div>
              </ButtonSection>
            </Col>
          </Row>
        </Form>
      </ValidationBoundary>
    </ErrorBoundary>
  )
}

export default RsaKeyPolicyForm



// WEBPACK FOOTER //
// ./src/components/administration/rsaKeyPolicy/RsaKeyPolicyForm.js